import React, { useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import { ClickAwayListener, MenuList, MenuItem as MaterialMenuItem, Popper, Paper } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from "./styles";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import useSettings from '../../../core/hooks/useCommonSettings';

const MenuItem = (props) => {
  const { subMenu: menu } = props;
  const classes = makeStyles(styles)();
  const menuIconRef = useRef(null);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  let history = useHistory();
  const {getActivePage} = useSettings();
  const handleMenuSelect = (route) => {
    setSubMenuOpen(false);
    history.push(route.url);
  };
  const handleMenuClose = () => {
    setSubMenuOpen(false);
  };
  const handleMouseEnter = (e) => {
    e.stopPropagation();
    setSubMenuOpen(true);
  };
  const handleMouseLeave = (e) => {
    e.stopPropagation();
    setSubMenuOpen(false);
  };
  return (
    <div onMouseLeave={handleMouseLeave}>
      <div
        attr={menu.key}
        className={clsx(classes.menuItem, getActivePage() === menu.key ? classes.selectedItemMenu : "")}
        ref={menuIconRef}
        onMouseEnter={handleMouseEnter}>
        {menu.key}
        <ExpandMoreIcon className={classes.downIcon}/>
      </div>
      <ClickAwayListener onClickAway={handleMenuClose}>
        <Popper
          open={subMenuOpen}
          anchorEl={menuIconRef.current}
          onClose={handleMenuClose}
          placement="bottom-start"
          style={{zIndex:2}}
          disablePortal>
          <Paper>
            <MenuList>
              {menu.subMenus.map((currentSubMenu) => {
                return <MaterialMenuItem className={classes.subMenuItem} key={currentSubMenu.menuLabel} onClick={() => handleMenuSelect(currentSubMenu)}>{currentSubMenu.menuLabel}</MaterialMenuItem>;
              })}
            </MenuList>
          </Paper>
        </Popper>
      </ClickAwayListener>
    </div>
  );
};

export default MenuItem;
